// Sonido de notificaciones por USUARIO (admin_users.sound_enabled): default ON,
// lo maneja un admin desde Usuarios del Sistema. Acá vive un ESPEJO en localStorage
// que se sincroniza al login y vía /api/me (AuthContext).
// El nivel "por dispositivo" se eliminó el 2026-07-14 a pedido de Esteban — con el
// control por usuario alcanza. La key vieja posberry_sounds_enabled quedó sin
// consumidores (un mute de dispositivo previo ya no silencia nada).

const USER_KEY = 'posberry_sounds_user_enabled';

export const SOUND_PREF_EVENT = 'posberry:sound-pref-changed';
// Tono de escalaciones elegido por el usuario (admin_users.escalation_sound),
// mismo patrón de espejo. Catálogo cerrado, espejo de crm/sonidos.py. NO hay
// opción "sin sonido": el operador siempre oye las escalaciones; silenciar es
// el flag de arriba, que sólo maneja un admin.
const TONO_KEY = 'posberry_escalation_sound';
export const TONO_DEFAULT = 'clasico';
export const TONOS_ESCALACION = [
  { id: 'clasico', label: 'Notificación 1', src: '/sounds/escalated.ogg' },
  { id: 'tono2', label: 'Notificación 2', src: '/sounds/escalated-2.ogg' },
  { id: 'tono3', label: 'Notificación 3', src: '/sounds/escalated-5.ogg' },
  { id: 'tono4', label: 'Notificación 4', src: '/sounds/escalated-4.ogg' },
];

export const tonoPorId = (id) =>
  TONOS_ESCALACION.find((t) => t.id === id) || TONOS_ESCALACION[0];

export const SOUND_STORAGE_KEYS = [USER_KEY, TONO_KEY];

// Lo que consultan los que suenan (Conversations, BadgesContext)
export const getSoundEnabled = () => {
  try {
    const v = localStorage.getItem(USER_KEY);
    if (v === null) return true;
    return v === '1' || v === 'true';
  } catch {
    return true;
  }
};

// Setter del espejo (lo llama AuthContext al login / sync de /api/me)
export const setUserSoundEnabled = (enabled) => {
  try {
    localStorage.setItem(USER_KEY, enabled ? '1' : '0');
  } catch {
    /* noop */
  }
  try {
    window.dispatchEvent(new CustomEvent(SOUND_PREF_EVENT, { detail: { enabled: getSoundEnabled() } }));
  } catch {
    /* noop */
  }
};

// Tono vigente (objeto del catálogo). Un id desconocido cae al clásico.
export const getEscalationSound = () => {
  try {
    return tonoPorId(localStorage.getItem(TONO_KEY));
  } catch {
    return TONOS_ESCALACION[0];
  }
};

// Setter del espejo (login, sync de /api/me, y al elegir en la página de Escalaciones)
export const setEscalationSound = (id) => {
  try {
    localStorage.setItem(TONO_KEY, tonoPorId(id).id);
  } catch {
    /* noop */
  }
  try {
    window.dispatchEvent(new CustomEvent(SOUND_PREF_EVENT, { detail: { enabled: getSoundEnabled() } }));
  } catch {
    /* noop */
  }
};

// Un Audio por archivo, creado a demanda (se reusa: la primera vez que suena
// ya está precargado si el tono vigente se pidió antes).
const audios = {};
export const audioDeTono = (id) => {
  if (typeof Audio === 'undefined') return null;
  const tono = tonoPorId(id);
  if (!audios[tono.id]) {
    audios[tono.id] = new Audio(tono.src);
    audios[tono.id].preload = 'auto';
  }
  return audios[tono.id];
};
